// extracted by mini-css-extract-plugin
module.exports = {"SubmissionsList":"SubmissionsList_SubmissionsList__1k4ih"};